
export const TOGGLE_NAV = "TOGGLE_NAV";
export const CHANGE_PATH = "CHANGE_PATH";
